(function () {
  function showNewBadges() {
    var now = Math.floor(Date.now() / 1000);
    document.querySelectorAll('.js-new-badge[hidden]').forEach(function (el) {
      var created = parseInt(el.dataset.created, 10);
      var maxAge = parseInt(el.dataset.maxAge, 10);
      if (now - created <= maxAge) el.removeAttribute('hidden');
    });
  }

  // Run once on page load
  showNewBadges();

  // Re-run whenever new content is added (sorting, filtering, quick add, recommendations)
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      showNewBadges();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();